// extracted by mini-css-extract-plugin
module.exports = {"root":"FloatingImageEditor_root__y9Ou7","inner":"FloatingImageEditor_inner___CgGb"};